module.exports = __webpack_public_path__ + "9aa773ea617245f4d504e359cc0cf077.svg";